import React, {useRef, useState, useEffect} from "react";
import classes from "./VerifyBatch.module.css";
import VerifySvg from "../../assets/verify.svg";
import {IoClose} from "react-icons/io5";
import VerifyBatchBanner from "../../assets/verifyBatchBanner.svg";
import VerifyBatchSuccess from "../../assets/verifyBatchSuccess.png";
import {PDFViewer} from "./PDFViewer";
import {Button} from "@mui/material";
import {MdOutlineFileDownload} from "react-icons/md";

const batchBaseURL = "https://s3.ap-south-1.amazonaws.com/data.eurocross.in/batchCertificates/";
const VerifyBatch = ({productDetails, closeModal}) => {
  const inpRef = useRef();
  const inpRef2 = useRef();
  const inpRef3 = useRef();
  const inpRef4 = useRef();
  const [uniqueId, setUniqueId] = useState([]);
  const [backCount, setBackCount] = useState(0);
  const [batchNoVerify, setBatchNoVerify] = useState("");
  const [showBatchFile, setShowBatchFile] = useState(false);
  const [verifiedBatch, setVerifiedBatch] = useState("");
  const [selectedBatchFile, setBatchFile] = useState(null);

  const checkUniqueId = (e, uid, id) => {
    let tempUID = [...uniqueId];
    let uidIndx = tempUID.findIndex((ele) => ele.uid === uid);

    const focusMap = {
      uid1: inpRef2,
      uid2: inpRef3,
      uid3: inpRef4,
      uid4: null, // Add if needed
    };

    if (batchNoVerify === "failed") setBatchNoVerify("");

    // Handle key other than Tab (9) and Backspace (8)
    if (e.keyCode !== 9 && e.keyCode !== 8) {
      if (!id) return;

      const upperId = id.toUpperCase();
      if (uidIndx >= 0) {
        tempUID[uidIndx].id = upperId;
      } else {
        tempUID.push({uid, id: upperId});
      }

      const nextRef = focusMap[uid];
      if (inpRef.current && nextRef?.current) {
        nextRef.current.focus();
      }

      setUniqueId(tempUID);
      return;
    }

    // Handle backspace
    if (e.keyCode === 8) {
      if (backCount + 1 === 2) {
        const prevFocusMap = {
          uid2: inpRef,
          uid3: inpRef2,
          uid4: inpRef3,
        };

        const prevRef = prevFocusMap[uid];
        if (inpRef.current && prevRef?.current) {
          prevRef.current.focus();
        }

        if (uidIndx !== -1 && !id) {
          tempUID.splice(uidIndx, 1);
          setUniqueId(tempUID);
        }

        setBackCount(0);
      } else {
        setBackCount((prev) => prev + 1);
      }
    }
  };

  const submitBatchID = () => {
    if (uniqueId.length === 4) {
      const batchFiles = productDetails?.batches || [];
      const uidOrder = ["uid1", "uid2", "uid3", "uid4"];
      const input = uidOrder.map((uid) => uniqueId.find((item) => item.uid === uid)?.id || "").join("");
      const matchedBatch = batchFiles.find(({batchId}) => {
        const upperBatch = batchId.toUpperCase();
        return input[0] === upperBatch[0] && input[1] === upperBatch[1] && input[2] === upperBatch[upperBatch.length - 2] && input[3] === upperBatch[upperBatch.length - 1];
      });


      if (matchedBatch) {
        setVerifiedBatch(matchedBatch.batchId.toUpperCase().split(""));
        setBatchFile(matchedBatch);
        setBatchNoVerify("verified");
      } else {
        setBatchNoVerify("failed");
      }
    } else {
      setBatchNoVerify("failed");
    }
  };

  const downloadPDF = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (batchNoVerify === "verified") {
      setTimeout(() => {
        setUniqueId([]);
        setShowBatchFile(true);
        inpRef?.current && (inpRef.current.value = "");
        inpRef2?.current && (inpRef2.current.value = "");
        inpRef3?.current && (inpRef3.current.value = "");
        inpRef4?.current && (inpRef4.current.value = "");
        setBatchNoVerify("");
      }, 2000);
    }
  }, [batchNoVerify]);

  useEffect(() => {
    if (productDetails?.batches && batchNoVerify !== "verified") {
      setTimeout(() => {
        inpRef.current && inpRef.current.focus();
      }, 200);
    }
  }, []);
  return (
    <div className={classes.verifyBatchDiv}>
      <div className={classes.header}>
        <div>
          <img src={VerifySvg} alt="VerifySVG" />
          Verify the quality
        </div>
        <div onClick={() => closeModal()}>
          <IoClose />
        </div>
      </div>
      <div style={{backgroundColor: "#FCFCFC"}}>
        {batchNoVerify !== "verified" && !showBatchFile ? (
          <>
            <div className={classes.verifyBatchBanner}>
              <img src={VerifyBatchBanner} alt="VerifyBatch" />
            </div>
            <div className={classes.verifySection}>
              <div>Batch Certificate</div>
              <div>
                Thank you for scanning Med-Scan of
                <br />
                <span className="font_600">{productDetails.name.toUpperCase()}</span>
              </div>
              <div>Please enter the first two and last two digits of the batch number</div>

              <div className={classes.verifyInputs}>
                <input autoFocus ref={inpRef} type="text" name="uid1" maxLength={1} onKeyUp={(e) => checkUniqueId(e, e.target.name, e.target.value)} />
                <input type="text" ref={inpRef2} name="uid2" maxLength={1} onKeyUp={(e) => checkUniqueId(e, e.target.name, e.target.value)} />
                {Array.from(new Array(productDetails.batches[0].batchId.length - 4), (el, indx) => (
                  <p>X</p>
                ))}
                <input type="text" ref={inpRef3} name="uid3" maxLength={1} onKeyUp={(e) => checkUniqueId(e, e.target.name, e.target.value)} />
                <input type="text" ref={inpRef4} name="uid4" maxLength={1} onKeyUp={(e) => checkUniqueId(e, e.target.name, e.target.value)} />
              </div>
              {batchNoVerify === "failed" && <div className={classes.failedMessage}>Please enter valid batch number!</div>}
            </div>
            <div className={classes.confirmDiv}>
              <Button variant="contained" onClick={() => submitBatchID()}>
                Confirm
              </Button>
            </div>
          </>
        ) : !showBatchFile ? (
          <div className={classes.successDiv}>
            <div>
              <img className={classes.verifySuccessImage} src={VerifyBatchSuccess} alt="Success" />
              <div className={classes.heading4}>You are all set!</div>
              <div className="font_14">
                Batch Certificate no <br />
                <span className="font_600">{verifiedBatch}</span> is verified
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={classes.pdfView}>
              <PDFViewer url={`${batchBaseURL}${selectedBatchFile?.batchFile}`} />
            </div>
            <div className={classes.confirmDiv}>
              <Button variant="contained" onClick={() => downloadPDF(`${batchBaseURL}${selectedBatchFile?.batchFile}`, selectedBatchFile?.batchFile)}>
                Download Batch Certificate &nbsp;
                <MdOutlineFileDownload />
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyBatch;
